// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteNav_wrapper__2iPvg","links":"SiteNav_links__bXTWr","activeLink":"SiteNav_activeLink__96M49","inactiveLink":"SiteNav_inactiveLink__29s8Y"};